import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import GlobalVariable from '../../GlobalVariable';
import api from '../../api';
import LessonTest, {TestQuestion} from './LessonTest';
import './Learning.scss';

type TestLesson = {title: string; categoryTitle: string | null; questions: TestQuestion[]};

export default function LessonTestPage({idLesson, idCategory}: {idLesson: string | number; idCategory: string | number}) {
    const [lesson, setLesson] = useState<TestLesson | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [reload, setReload] = useState(0);
    const backUrl = `/knowledge-base/${idCategory}/lesson/${idLesson}`;

    useEffect(() => {
        let active = true;
        window.scrollTo(0, 0);
        setLoading(true);
        setError('');
        api.post(GlobalVariable.staffBack() + '/getLesson/' + idLesson, {}, {withCredentials: true})
            .then(response => {
                if (!active) return;
                setLesson(response.data);
                setLoading(false);
            }).catch(() => {
                if (!active) return;
                setError('Не удалось загрузить тест. Попробуйте ещё раз.');
                setLoading(false);
            });
        return () => { active = false; };
    }, [idLesson, reload]);

    return <div className='main learning-page learning-test-page'>
        <div className='learning-test-shell'>
            <Link className='learning-test-back' to={backUrl} aria-label='Вернуться к уроку'>← <span>К уроку</span></Link>
            <div className='learning-test-heading'>
                <span className='learning-eyebrow'>{lesson?.categoryTitle || 'Обучение'}</span>
                <h1>{lesson?.title || 'Тест по уроку'}</h1>
                {!loading && !error && lesson && lesson.questions.length > 0 && <p>Для прохождения нужно правильно ответить минимум на 80% вопросов.</p>}
            </div>
            {loading && <div className='learning-state' role='status'>Загружаем тест…</div>}
            {error && <div className='learning-state is-error' role='alert'>{error}<button type='button' onClick={() => setReload(value => value + 1)}>Повторить</button></div>}
            {!loading && !error && lesson && (lesson.questions.length > 0
                ? <LessonTest lessonId={Number(idLesson)} questions={lesson.questions} backUrl={backUrl}/>
                : <div className='learning-empty'>В этом уроке пока нет теста. <Link to={backUrl}>Вернуться к материалу</Link></div>)}
        </div>
    </div>;
}
